import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['root', 'price', 'cta'],
    base: {
        root: {
            display: 'inline-flex',
            alignItems: 'center',
            paddingLeft: 'spacing-20',
            paddingRight: 'spacing-4',
            paddingTop: 'spacing-4',
            paddingBottom: 'spacing-4',
            borderRadius: 'round',
            bg: 'background.actions.ghost',
            backdropFilter: 'blur(8px)'
        },
        price: {
            color: 'text.primary'
        },
        cta: {
            flex: '1 1 auto',
            minWidth: 0
        }
    },
    variants: {
        size: {
            small: {
                root: {
                    textStyle: 'body.small',
                    gap: 'spacing-12'
                },
                cta: {
                    size: 'md'
                }
            },
            large: {
                root: {
                    textStyle: 'body.medium',
                    gap: 'spacing-16'
                },
                cta: {
                    size: 'lg'
                }
            }
        },
        hasPrice: {
            true: {},
            false: {
                root: {
                    display: 'contents'
                },
                cta: {
                    size: 'lg'
                }
            }
        },
        variant: {
            // for highlight stacks module
            lifestyle: {
                root: {bg: 'background.actions.on-media.ghost'},
                price: {
                    color: 'text.on-media.primary'
                }
            },
            comparisonTable: {
                root: {bg: 'transparent'}
            }
        }
    },
    defaultVariants: {
        size: 'large',
        hasPrice: true,
        variant: 'default'
    }
})
